<!--
/*******************************************************************************
*@ 컴포넌트명   : CorporationInfoTab2.vue
*@ 컴포넌트설명 : 고객정보조회/변경 - 수정 [기업] : 법인주소
*@ 사용전문     : 
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <div class="form">
    <!-- 우편번호 -->
    <div class="form-row">
      <input-text
        ref="coprNmad"
        id="coprNmad"
        :value.sync="data.coprNmad"
        label-i18n="MCOP-01-01-04-06"
        placeholder="MCOP-01-01-04-06"
        :maxlength="10"
        :err-msg-param="{filed:$t('MCOP-01-01-04-06'), max:10}"
        toLowerCase
      />
    </div>
    <!-- 상세 주소 : 인도, 오클랜드 제외 -->
    <div class="form-row">
      <div class="item-tit">
        {{ /*상세 주소*/ $t("MCOP-01-01-04-07") }}
        <required />
      </div>
      <div class="item-desc">
        <div class="form-text-field">
          <div class="input-text-field address">
            <input-text
              ref="coprAddr1"
              id="coprAddr1"
              :value.sync="data.coprAddr1"
              placeholder="MCOP-01-01-04-07"
              :maxlength="66"
              :err-msg-param="{filed:$t('MCOP-01-01-04-07'), max:66}"
              :required="`${$config.SITECODE_OGCBD}|${$config.SITECODE_OGHCM}|${$config.SITECODE_OGMMR}`"
              toLowerCase
            />
          </div>
          <div class="input-text-field">
            <input-text
              ref="coprAddr2"
              id="coprAddr2"
              :value.sync="data.coprAddr2"
              :maxlength="66"
              :err-msg-param="{filed:$t('MCOP-01-01-04-07'), max:66}"
              toLowerCase
            />
          </div>
        </div>
      </div>
    </div>
    <!-- 도시, 국가 -->
    <div class="form-row">
      <input-text
        ref="coprAddr3"
        id="coprAddr3"
        :value.sync="data.coprAddr3"
        label-i18n="MCOP-01-01-04-08"
        placeholder="MCOP-01-01-04-08"
        toLowerCase
      />
    </div>
  </div>
</template>
<script>
import Required from "@/components/template/Required";
import { mapFields } from "vuex-map-fields";

export default {
  props: ["data"],
  components: {
    Required,
  },
  computed: {
    ...mapFields(["siteCode"]),
  },
  methods: {
    touch() {
      this.$refs.coprNmad.$v.$touch();
      this.$refs.coprAddr1.$v.$touch();
      this.$refs.coprAddr2.$v.$touch();
      this.$refs.coprAddr3.$v.$touch();
    },
  },
};
</script>